import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import useActivityFeed from "../../hooks/useActivityFeed";
import useActivityTypes from "../../hooks/useActivityTypes";
import useAutoRefresh from "../../hooks/useAutoRefresh";
import { GlassFeedContainer } from "../layouts/GlassTileLayout";
import ActivityFeedHeader from "./ActivityFeedHeader";
import ActivityFeedContent from "./ActivityFeedContent";

const ActivityFeed = ({
  feedType = "global",
  diverId = null,
  divesiteId = null,
  autoRefresh = true,
  refreshInterval = 30000, // 30 seconds
  style = {},
  ...props
}) => {
  const { currentUser, userObjectId } = useAuth();
  const [filter, setFilter] = useState("");

  // Custom hooks
  const { activities, loading, error, hasMore, loadMore, refreshFeed } =
    useActivityFeed(
      feedType,
      diverId,
      divesiteId,
      filter,
      currentUser,
      userObjectId
    );

  const { activityTypes } = useActivityTypes(currentUser);

  // Auto-refresh functionality
  useAutoRefresh(autoRefresh, refreshInterval, refreshFeed);

  // Helper function to get feed title
  const getFeedTitle = () => {
    switch (feedType) {
      case "personal":
        return "My Activity";
      case "global":
        return "Recent Activity";
      case "divesite":
        return "Site Activity";
      default:
        return "Activity Feed";
    }
  };

  return (
    <GlassFeedContainer style={style} {...props}>
      <ActivityFeedHeader
        title={getFeedTitle()}
        onRefresh={refreshFeed}
        loading={loading}
        filter={filter}
        onFilterChange={setFilter}
        activityTypes={activityTypes}
      />

      <ActivityFeedContent
        activities={activities}
        loading={loading}
        error={error}
        hasMore={hasMore}
        onLoadMore={loadMore}
      />
    </GlassFeedContainer>
  );
};

export default ActivityFeed;
